import { render, staticRenderFns } from "./pubCnyGoodExpt.vue?vue&type=template&id=ecb0ee58&scoped=true&"
import script from "./pubCnyGoodExpt.vue?vue&type=script&lang=js&"
export * from "./pubCnyGoodExpt.vue?vue&type=script&lang=js&"
import style0 from "./pubCnyGoodExpt.vue?vue&type=style&index=0&id=ecb0ee58&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb0ee58",
  null
  
)

export default component.exports